export function feddbackApi(formData: FormData) {
	// fetch('http://platy/api/feedback', {

	return fetch('https://www.woer.ru/api/feedback', {
		// fetch('https://platy.m-pcb.ru/api/feedback', {
		// fetch('/api/feedback', {
		method: 'post',
		credentials: 'same-origin',
		redirect: 'follow',
		mode: 'cors',
		body: formData
	}).then((response) => {
		if (response.ok) {
			return response.json();
		} else {
			// @ts-ignore
			return Promise.reject('error');
		}
	});
}
